export default __webpack_public_path__ + "static/media/greenKalenday.bf9ef020.png";